<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/login/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:22:50
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-21 16:42:25
-->
<template>
  <div class="login">
    <nav-bar @back="back" />
    <page-title :title="isPasswdLogin ? '密码登录' : '手机号登录'" />
    <div class="login_con">
      <van-form ref="login" @submit="onSubmit">
        <!-- 手机号 -->
        <phone-field v-model="phone" @prefixChange="prefixChange" />
        <!-- 验证码 -->
        <code-field
          v-if="!isPasswdLogin"
          v-model="verifyCode"
          :phone="checkPhone"
          @senderCode="senderCode"
          @verifyCodeChange="verifyCodeChange"
        />
        <!-- 密码 -->
        <password-field v-if="isPasswdLogin" v-model="password" />
        <!-- 协议 -->
        <agreement v-model="agree" />
        <div class="actions">
          <!-- 登录按钮 -->
          <van-button
            block
            type="info"
            native-type="submit"
            class="login_submit"
            :disabled="disabledBtn"
          >
            登录
          </van-button>
        </div>
      </van-form>
      <div v-if="errorMsg" class="login_error">
        {{ errorMsg }}
      </div>
      <div class="login_switch">
        <span @click="swichLoginMethod">
          {{ isPasswdLogin ? "验证码登录" : "密码登录" }}
        </span>
        <span v-if="isPasswdLogin" class="forgot" @click="goForgot">
          忘记密码
        </span>
      </div>
      <div class="wechat_con">
        <wechat-button @wechat="wechat" />
      </div>
    </div>
  </div>
</template>

<script>
import wechat from "@/utils/wechat";
import { verifyPhone } from "@/utils";

const NavBar = () => import("./components/NavBar");
const PageTitle = () => import("./components/PageTitle");
const PhoneField = () => import("./components/PhoneField");
const CodeField = () => import("./components/CodeField");
const Agreement = () => import("./components/Agreement");
const WechatButton = () => import("./components/WechatButton");
const PasswordField = () => import("./components/PasswordField");

export default {
  components: {
    NavBar,
    PageTitle,
    PhoneField,
    PasswordField,
    CodeField,
    Agreement,
    WechatButton
  },
  data() {
    return {
      redirect: undefined,
      otherQuery: {},
      prefix: "+86",
      phone: "",
      verifyCode: "",
      agree: "0",
      errorMsg: "",
      isPasswdLogin: false,
      password: "",
      path: ""
    };
  },
  computed: {
    disabledBtn() {
      if (this.agree === "1" && verifyPhone(this.prefix, this.phone)) {
        if (!this.isPasswdLogin) {
          if (this.verifyCode.length === 6) {
            return false;
          }
        } else {
          if (this.password.length >= 6) {
            return false;
          }
        }
      }
      return true;
    },
    checkPhone() {
      return verifyPhone(this.prefix, this.phone);
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  mounted() {
    /** 是否要判断guid相同 保证是同一次发起的，暂时未想好 */
    // const arr = window.location.href.split("#");
    // if (arr.length > 1) {
    //   const guid = arr[1];
    //   console.log(guid);
    // }
    // wechatLogin 微信登录
    const query = this.$route.query;
    if (query.code) {
      this.$store
        .dispatch("login/wechatLogin", {
          params: {
            clientCode: query.code
          }
        })
        .then(() => {
          this.$router.push({
            path: this.redirect || "/",
            query: this.otherQuery
          });
          // console.log(res, "微信登录返回res");
          // this.$router.push({
          //   path: this.redirect || "/",
          //   query: this.otherQuery
          // });
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // 获取微信登录code
    wechat() {
      wechat();
    },
    prefixChange(value) {
      this.prefix = value;
    },
    // 验证码/密码登录切换
    swichLoginMethod() {
      this.isPasswdLogin = !this.isPasswdLogin;
    },
    onSubmit(values) {
      // console.log(values, this.phone, this.agree);
      if (!verifyPhone(this.prefix, values.phone)) {
        this.errorMsg = "手机号码格式不正确";
        return;
      }
      const data = {
        phone: this.phone
      };
      // console.log(this.isPasswdLogin, "this.isPasswdLogin");
      var dataUrl = "login/accountLogin";
      if (this.isPasswdLogin) {
        data.password = values.password;
      } else {
        data.code = values.verifyCode;
        data.slug = this.slug;
        data.kind = "Login";
        dataUrl = "login/phoneLogin";
      }
      this.$store
        .dispatch(dataUrl, {
          params: data
        })
        .then(() => {
          this.$router.push({
            path: this.redirect || "/",
            query: this.otherQuery
          });
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    },
    goForgot() {
      this.$router.push("/forgot");
    },
    // 验证码
    verifyCodeChange(value) {
      this.verifyCode = value;
    },
    // 发送验证码
    senderCode(callback) {
      const data = {
        phone: this.phone,
        kind: "Login"
      };
      this.$store
        .dispatch("login/sendSms", {
          params: data
        })
        .then(() => {
          this.$toast("验证码已发送到您的手机");
          callback();
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: left;

  .login_close {
    width: 24px;
    margin: 11px 0 0 24px;
  }
  .login_title {
    margin-top: 30px;
    line-height: 33px;
  }

  .login_con {
    margin: 72px 38px;
  }

  .actions {
    margin-top: 12px;

    .login_submit {
      background: var(--linear-gradient);
      border: none;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
    }
  }

  .login_error {
    padding: 4px;
    color: #ff0000;
    font-size: 12px;
    text-align: center;
  }

  .login_switch {
    padding: 10px 0;
    font-size: 12px;
    font-weight: 400;

    span {
      cursor: pointer;
    }

    .forgot {
      float: right;
    }
  }

  .wechat_con {
    margin-top: 80px;
  }

  .van-cell {
    padding: 10px 0;
  }
}
</style>
